<template>
  <Toolbar classes="pt-3">
    <template v-slot:actions>
      <div class="d-flex align-items-center">
        <router-link to="/surveys" class="btn btn-sm btn-light">
          <i class="bi bi-arrow-left me-1"></i>
          Voltar
        </router-link>
      </div>
    </template>
  </Toolbar>

  <div class="container-xxl">
    <div class="card">
      <div class="card-body py-4">
        <div class="row">
          <div class="col-md-4">
            <Dropdown
              :showClear="true"
              :options="professionals"
              :filter="true"
              @change="resetPage();"
              v-model="filters.professionalId"
              optionLabel="prof_name"
              optionValue="id_prof"
              id="id_prof"
              class="form-control form-control-solid"
              style="display: flex; padding: 0.35rem 0.75rem"
              placeholder="Selecione um profissional"
            />
          </div>
          <div class="col-md-2">
            <Calendar class="form-control form-control-sm w-full md:w-14rem"
                      @change="resetPage();" showButtonBar
                      dateFormat="dd/mm/yy" v-model="filters.startDate"/>
          </div>
          <div class="col-md-2">
            <Calendar class="form-control form-control-sm w-full md:w-14rem"
                      @change="resetPage();" showButtonBar
                      dateFormat="dd/mm/yy" v-model="filters.endDate"/>
          </div>
          <div class="col-md-2">
            <button class="btn btn-primary" type="button" @click="fetchAnswers();">
              Filtrar <i class="bi bi-search"></i>
            </button>
          </div>
          <div class="col-md-2" style="display: none">
            <button class="btn btn-primary w-100" type="button" @click="exportAnswers">
              Exportar <i class="bi bi-download"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="card">
      <div class="card-body py-4">
        <div class="table-responsive">
          <table class="table table-hover table-row-bordered">
            <thead>
            <tr class="fw-bold fs-6 text-muted">
              <th>Paciente</th>
              <th>Profissional</th>
              <th>Data envio</th>
              <th>Data resposta</th>
              <th>Média de avaliação</th>
              <th>Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="answer in answers.data">
              <td class="d-flex align-items-center">
                <div class="d-flex flex-column">
                  <span class="text-gray-800 text-hover-primary mb-1">{{ answer.patient.patient_name }}</span>
                  <span>{{ answer.patient.patient_cpf }}</span>
                </div>
              </td>
              <td>{{ answer.schedule?.professional?.prof_name }}</td>
              <td>{{ formatDate(answer.token.created_at) }}</td>
              <td>{{ formatDate(answer.created_at) }}</td>
              <td>{{ answer.answer_medium }}</td>
              <td>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="showSurveyQuestions(answer)"
                        title="Verificar respostas">
                  <i class="bi bi-question-circle"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>

          <Pagination :data="answers"/>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalAnswerSurveyQuestions"
         tabindex="-1" aria-labelledby="modalSurveyQuestions" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-light">
            <div class="d-flex align-items-center">
              <div>
                <h5 class="modal-title mb-0">Respostas da Pesquisa</h5>
                <span class="text-muted fs-7">Visualize as respostas do paciente</span>
              </div>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="selectedAnswer" class="row g-4">
              <!-- Informações do Paciente -->
              <div class="col-12">
                <div class="card border-0 bg-light bg-opacity-50">
                  <div class="card-body p-4">
                    <div class="row">
                      <div class="col-md-6">
                        <label class="form-label fw-semibold text-muted">Paciente</label>
                        <p class="mb-0 fw-bold">{{ selectedAnswer.patient?.patient_name }}</p>
                      </div>
                      <div class="col-md-6">
                        <label class="form-label fw-semibold text-muted">Profissional</label>
                        <p class="mb-0 fw-bold">{{ selectedAnswer.schedule?.professional?.prof_name || '-' }}</p>
                      </div>
                      <div class="col-md-6 mt-3">
                        <label class="form-label fw-semibold text-muted">Data/Hora do Agendamento</label>
                        <p class="mb-0">
                          <span v-if="selectedAnswer.schedule?.sched_date && selectedAnswer.schedule?.sched_time">
                            {{ formatDateTime(selectedAnswer.schedule.sched_date, selectedAnswer.schedule.sched_time) }}
                          </span>
                          <span v-else class="text-muted">-</span>
                        </p>
                      </div>
                      <div class="col-md-6 mt-3">
                        <label class="form-label fw-semibold text-muted">Respondido em</label>
                        <p class="mb-0">{{ formatDateTimeFull(selectedAnswer.created_at) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Respostas -->
              <div class="col-12">
                <div class="card border-0">
                  <div class="card-header bg-primary bg-opacity-10 border-bottom-0">
                    <h6 class="card-title text-white mb-0 fw-bold">
                      Respostas da Pesquisa
                    </h6>
                  </div>
                  <div class="card-body">
                    <div v-if="questions && questions.length > 0" class="row g-3">
                      <div v-for="(answer, index) in questions" :key="index" class="col-12">
                        <div class="card card-bordered">
                          <div class="card-body p-4">
                            <div class="d-flex align-items-start">
                              <div class="symbol symbol-35px me-3">
                                <div class="symbol-label bg-light-primary text-primary fw-bold">
                                  {{ index + 1 }}
                                </div>
                              </div>
                              <div class="flex-grow-1">
                                <h6 class="mb-2 text-gray-800 fw-semibold">{{ answer.question?.sq_question }}</h6>
                                <div class="mt-3 p-3 bg-light bg-opacity-50 rounded">
                                  <div class="mb-1">
                                    <strong class="text-primary">Resposta:</strong>
                                  </div>
                                  <div class="mt-2">
                                    <span v-if="answer.sa_option_text || answer.sa_answer" class="fw-normal">
                                      {{ answer.sa_option_text || answer.sa_answer }}
                                    </span>
                                    <span v-else class="text-muted fst-italic">
                                      Não respondido
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="text-center py-5">
                      <div class="symbol symbol-50px mb-3 mx-auto">
                        <div class="symbol-label bg-light">
                          <i class="bi bi-question-circle text-muted fs-2x"></i>
                        </div>
                      </div>
                      <p class="text-muted">Nenhuma resposta encontrada</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import http from "@/helpers/http";
import Pagination from "@/components/Pagination.vue";
import Calendar from "primevue/calendar";
import Download from "@/helpers/download";
import Loader from "@/helpers/loader";
import Alert from "@/helpers/alert";
import Toolbar from "@/components/layouts/auth/Toolbar.vue";
import Dropdown from "primevue/dropdown";
import MultiSelect from "primevue/multiselect";
import Modal from "@/helpers/modal";

export default {
  name: "SurveyAnswer",
  components: {MultiSelect, Dropdown, Pagination, Calendar, Toolbar},
  data() {
    return {
      filters: {
        search: '',
        professionalId: null,
        startDate: null,
        endDate: null,
      },
      answers: [],
      questions: [],
      selectedAnswer: null,
      surveyId: null,
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    professionals() {
      return this.$store.state.auth.professionals;
    },
  },
  mounted() {
    this.surveyId = this.$route.params.surveyId;
    this.resetPage();
    this.fetchAnswers();
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('pt-BR');
    },
    formatDateTime(date, time) {
      if (!date) return '-';
      const dateStr = new Date(date).toLocaleDateString('pt-BR');
      return time ? `${dateStr} às ${time}` : dateStr;
    },
    formatDateTimeFull(dateTime) {
      if (!dateTime) return '-';
      return new Date(dateTime).toLocaleString('pt-BR');
    },
    async exportAnswers() {
      Loader.show('Gerando Relatório', 'Aguarde');
      try {
        const response = await http.get(`/places/${this.place.id_place}/${this.surveyId}/answers/export`, {
          params: {
            'search': this.filters.search,
            'id_prof': this.filters.professionalId,
            'start_date': this.filters.startDate,
            'end_date': this.filters.endDate,
          },
          responseType: 'blob'
        });

        Download.downloadCSV(response.data, 'respostas.csv');
      } catch (error) {
        Alert.error(error)
      }
    },
    showSurveyQuestions(answer) {
      this.selectedAnswer = answer;
      this.questions = answer.token?.answers || [];
      Modal.toggle('#modalAnswerSurveyQuestions');
    },
    fetchAnswers() {
      this.answers = [];
      http.get(`/places/${this.place.id_place}/surveys/${this.surveyId}/answers`, {
        params: {
          'page': this.$route.query.page,
          'per_page': 10,
          'search': this.filters.search,
          'id_prof': this.filters.professionalId,
          'start_date': this.filters.startDate,
          'end_date': this.filters.endDate,
        }
      }).then((response) => {
        this.answers = response.data;
      });
    },
    resetPage() {
      const query = {...this.$route.query, page: 1};
      this.$router.push({path: this.$route.path, query});
    },
  },
}
</script>


<style scoped>
.card-bordered {
  border: 1px solid var(--bs-border-color);
  border-radius: 0.75rem;
  box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
}

.text-gray-800 {
  color: #3f4254 !important;
}

.fs-7 {
  font-size: 0.875rem;
}

.symbol-35px {
  width: 35px;
  height: 35px;
}

.symbol-50px {
  width: 50px;
  height: 50px;
}

.fs-2x {
  font-size: 2rem;
}

.bg-light-primary {
  background-color: #f1faff !important;
}

.fst-italic {
  font-style: italic;
}
</style>